// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__ydOOe","title":"Images90_title__1VLsh","images":"Images90_images__2ppAZ"};